import ExerciseCategories from '../container/Health/Categories/categoriesList';
import HealthDashboard from '../container/Health/Dashboard/Dashboard';
import Fitness from '../container/Health/Dashboard/Fitness/Fitness';
import Nutrition from '../container/Health/Dashboard/Nutrition/Nutrition';
import Equipment from '../container/Health/Equipment/Equipment';
import Exercises from '../container/Health/Exercises/Exercises';
import NewExercise from '../container/Health/Exercises/NewExercise';
import Meals from '../container/Health/Meals/Meals';
import NewRecipe from '../container/Health/Meals/NewRecipe';
import ViewRecipe from '../container/Health/Meals/viewRecipe';
import NewWorkoutPlans from '../container/Health/Workout-Plans/NewWorkoutPlans';
import ViewWorkoutPlans from '../container/Health/Workout-Plans/viewWorkoutPlans';
import WorkoutPlans from '../container/Health/Workout-Plans/WorkoutPlan';
import NewWorkout from '../container/Health/Workout/NewWorkout';
import ViewWorkout from '../container/Health/Workout/viewWorkout';
import Workouts from '../container/Health/Workout/Workout';
import FitnessDashboard from '../container/SoorahHealth/Fitness/FitnessDashboard';

// Elite Games child routes
const healthRoutes = [
  // QuizZone Routes
  {
    path: '',
    redirectTo: 'health-dashboard'
  },
  {
    path: 'health-dashboard',
    name: 'health-dashboard',
    component: HealthDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'health-fitness',
    name: 'health-fitness',
    component: Fitness,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'health-nutrition',
    name: 'health-nutrition',
    component: Nutrition,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'health-categories',
    name: 'health-categories',
    component: ExerciseCategories,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'equipments',
    name: 'equipments',
    component: Equipment,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'exercises',
    name: 'exercises',
    component: Exercises,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'exercise/new',
    name: 'exercise-new',
    component: NewExercise,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'workouts',
    name: 'workouts',
    component: Workouts,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'recipes',
    name: 'recipes',
    component: Meals,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'recipe/new',
    name: 'recipe-new',
    component: NewRecipe,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'recipe/:id',
    name: 'recipe-view',
    component: ViewRecipe,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  {
    path: 'workout/new',
    name: 'workout',
    component: NewWorkout,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'workout/edit',
    name: 'workouts',
    component: NewWorkout,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'workout/:id',
    name: 'workouts',
    component: ViewWorkout,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'workout-plans',
    name: 'workout-plans',
    component: WorkoutPlans,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'workout-plan/new',
    name: 'workout-plan-new',
    component: NewWorkoutPlans,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'workout-plan/:id',
    name: 'workout-plan-view',
    component: ViewWorkoutPlans,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  }
];
export default healthRoutes;
